export class VentilationFrequency {
  static SUMMER_ONLY = 1;
  static SPORADICALLY = 2;
  static OFTEN = 3;
  static VERY_OFTEN = 4;
  static NON_STOP = 5;
  static STANDARD = 6;
}
